import { render, staticRenderFns } from "./RelativeRelationTypeUpdate.vue?vue&type=template&id=be88ce56&"
import script from "./RelativeRelationTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports